import { SET_CURRENT_USER, SET_USERS } from "../constants/actionTypes";

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    currentUser: user,
  };
}

export function setUsers(users) {
  return {
    type: SET_USERS,
    users: users,
  };
}
